<template>
	<div
		v-bind:class="{
			closed: !expanded && hideNoResults,
			'is-flex': true,
			'is-flex-wrap-nowrap': true
		}">
		<div class="flex-item-expanded">
			<o-autocomplete
				v-model="text"
				:data="acOptionsFiltered"
				:debounceTyping="300"
				field="Text"
				:placeholder="placeholder"
				open-on-focus
				expanded
				:clear-on-select="clearOnSelect"
				@focus="focussing = true"
				@blur="focussing = false"
				@typing="LoadAcOptions"
				@select="SelectRow">
				<template v-slot:empty>No results</template>
			</o-autocomplete>
		</div>
		<o-button icon-left="chevron-up" inverted class="ac-uncollapse" v-show="focussing"></o-button>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted, nextTick } from "vue";
	export default {
		props: {
			modelValue: {
				type: [String, Number],
				default: null
			},
			displayText: {
				type: String,
				default: null
			},
			type: {
				type: String,
				default: null
			},
			data: {
				type: Array,
				default: () => {
					return [];
				}
			},
			placeholder: {
				type: String,
				default: ""
			},
			clearOnSelect: {
				type: Boolean,
				default: false
			},
			hideNoResults: {
				type: Boolean,
				default: false
			},
			blfCertified: {
				type: Boolean,
				default: false
			}
		},
		emits: ["update:modelValue", "input"],
		setup(props, context) {
			const $http = inject("$http");

			const selection = ref(props.modelValue || null);
			const text = ref(props.displayText || "");
			const focussing = ref(false);

			const options = ref([]);

			const UpdateModel = () => {
				context.emit("update:modelValue", selection.value);
			};
			const expanded = ref(true);

			const acOptionsFiltered = computed(() => {
				return options.value.filter((option) =>
					(option.Text || "")
						.toString()
						.toUpperCase()
						.indexOf((text.value || "").toUpperCase() >= 0)
				);
			});

			const url = computed(() => {
				const qs =
					"?" +
					[
						{ k: "query", v: text.value || "" },
						{ k: "blf_certified", v: props.blfCertified }
					]
						.filter((r) => r.v)
						.map((r) => r.k + "=" + r.v)
						.join("&");

				switch (props.type) {
					case "function": {
						return "/api/v2/function/filter" + qs;
					}
					case "industry": {
						return "/api/v2/industry/filter" + qs;
					}
					case "region": {
						return "/api/v2/region/filter" + qs;
					}
					case "license": {
						return "/api/v2/license/filter" + qs;
					}
					case "location": {
						return "/api/v2/location/filter" + qs;
					}
					case "country": {
						return "/api/v2/country/filter" + qs;
					}
					case "company": {
						return "/api/v2/company/filter" + qs;
					}
					case "user": {
						return "/api/v2/user/filter" + qs;
					}
					case "developer": {
						return "/api/v2/user/filter/developers" + qs;
					}
					case "researcher": {
						return "/api/v2/user/filter/researchers" + qs;
					}
					case "handler": {
						return "/api/v2/user/filter/handlers" + qs;
					}
					case "practiceGroup": {
						return "/api/v2/practiceGroup/filter" + qs;
					}
					case "subsector": {
						return "/api/v2/practiceGroup/subsectors/filter" + qs;
					}
					case "skill": {
						return "/api/v2/skill/filter" + qs;
					}
					default:
						return null;
				}
			});

			const LoadAcOptions = () => {
				if (url.value) {
					$http
						.get(url.value)
						.then((resp) => {
							options.value = resp.data;
							if (options.value.length == 0) {
								expanded.value = false;
							} else expanded.value = true;
						})
						.catch((err) => {
							options.value = [];
							console.log("OPTIONS Err", options.value, err);
						});
				} else {
					options.value = props.data;
				}
			};

			const SelectRow = (row) => {
				if (row) {
					selection.value = row.Id;

					UpdateModel();
					context.emit("input", {
						id: row.Id,
						text: row.Text,
						type: props.type,
						ClearText: () => {
							nextTick(() => {
								text.value = "";
							});
						}
					});
				}
			};

			const ConvertTypeIdToListItem = (row) => {
				switch (props.type) {
					case "function": {
						return { Id: row.ID, Text: row.Name };
					}
					case "industry": {
						return { Id: row.ID, Text: row.Name };
					}
					case "region": {
						return { Id: row.ID, Text: row.Name };
					}
					case "license": {
						return { Id: row.ID, Text: row.Name };
					}
					case "location": {
						return { Id: row.ID, Text: row.Name };
					}
					case "country": {
						return { Id: row.ID, Text: row.Name };
					}
					case "company": {
						return { Id: row.ID, Text: row.Name };
					}
					case "user": {
						return { Id: row.ID, Text: row.FullName };
					}
					case "developer": {
						return { Id: row.ID, Text: row.FullName };
					}
					case "researcher": {
						return { Id: row.ID, Text: row.FullName };
					}
					case "handler": {
						return { Id: row.ID, Text: row.FullName };
					}
					case "practiceGroup": {
						return { Id: row.ID, Text: row.Name };
					}
					case "subsector": {
						return { Id: row.ID, Text: row.Name };
					}
					case "skill": {
						return { Id: row.ID, Text: row.Name };
					}
					default: {
						return { Id: 0, Text: "Null" };
					}
				}
			};

			const GetElementById = () => {
				const idUrl = url.value.replace(/\/filter.*/, "/" + selection.value);
				$http.get(idUrl).then((resp) => {
					const row = ConvertTypeIdToListItem(resp.data);
					options.value.push(row);
					text.value = row.Text;
				});
			};

			onMounted(async () => {
				await LoadAcOptions();
				if (selection.value) {
					GetElementById();
				}
			});

			return {
				text,
				focussing,
				acOptionsFiltered,
				LoadAcOptions,
				SelectRow,
				expanded
			};
		}
	};
</script>
<style lang="scss" scoped>
	.closed:deep(.dropdown-item) {
		display: none;
	}
	.closed:deep(.dropdown-content) {
		display: none;
	}
</style>